module.exports = __webpack_public_path__ + "images/partner1.5b15209b.svg";